{
  "apply": "Apply ({count})",
  "buttonLabel": "Filters",
  "close": "Close",
  "deleteSelectedFilter": "Delete the selected filter",
  "header": "Filters",
  "searchByName": "Search by name",
  "model": "Model",
  "type": "Type",
  "clearFilters": "Clear filters",
  "connectivity": "Connectivity",
  "certificate": "Certificate",
  "state": "State",
  "certificateValidity": {
    "title": "Certificate validity",
    "expired": "Only expired",
    "validityUnder1": "Only < 1 month",
    "validityUnder3": "Only < 3 months",
    "validityUnder6": "Only < 6 months",
    "validityAfter6": "Only > 6 months",
    "label": "certificate expiration date"
  },
  "validityInMonth": "The selected validity is in month",
  "range": "Range",
  "creationDate": {
    "label": "date",
    "formatter": {
      "input": "YYYY-MM-DD",
      "tag": "YYYY-MM-DD"
    },
    "periodSeparator": "to",
    "placeholder": "Select a period"
  },
  "selectCreationDate": "Select the date",
  "date": {
    "to": "to",
    "startPlaceholder": "Start Date",
    "endPlaceholder": "End Date",
    "formatter": {
      "tag": "YYYY-MM-DD"
    },
    "periodSeparator": "to",
    "period": {
      "placeholder": "Select a period",
      "separator": "to"
    }
  },
  "resetFilter": "Reset filter | Reset filters",
  "validateFilter": "Validate filter",
  "searchDevice": "Search for devices",
  "sector": "Sector",
  "searchOperations": "Search for operations",
  "searchByLastNameOrFirstName": "Search by last name or first name",
  "search": "Search",
  "status": "Status",
  "firmware": {
    "range": "Device types"
  },
  "connectivityState": {
    "active": "Connected",
    "inactive": "Inactive"
  }
}
